module.exports = __webpack_public_path__ + "img/Express Deal.cf55a5da.gif";